import { FaIcon, faTruckRampCouchSolid } from '@/lib/fa'
import { getActivityIcon } from '@/modules/drivers/helpers/ActivityIconResolver'
import { getActivityName } from '@/modules/drivers/helpers/ActivityNameResolver'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import React from 'react'
import moment from 'moment'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { DividerHorizontal } from '@/modules/drivers/shared/DividerHorizontal'

const ActivityListChange = ({
  activitiesToEdit,
}: {
  activitiesToEdit: any[]
}) => {
  const { t } = useLocalize()

  return (
    <>
      <div className="tw-flex tw-flex-col tw-gap-2">
        <div className="tw-jusit tw-flex tw-flex-1 tw-items-start tw-gap-2 tw-font-medium tw-text-content-base">
          <FaIcon icon={faTruckRampCouchSolid} className="tw-max-w-[12px]" />
          <p className="tw-text-sm tw-font-semibold tw-text-content-base">
            {t('activityChartActions.activities-to-change') ||
              `Aktywności do zmiany (${activitiesToEdit.length})`}
          </p>
        </div>

        <div className="tw-flex tw-flex-col tw-gap-1.5">
          {activitiesToEdit.map((activity, idx) => {
            const start = moment(activity.startTime)
            const end = activity.endTime ? moment(activity.endTime) : null
            return (
              <div
                key={activity.id ?? idx}
                className="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-rounded-md tw-border tw-border-base-300 tw-bg-base-100 tw-px-3 tw-py-2 tw-text-sm"
              >
                <div className="tw-flex tw-items-center tw-gap-3">
                  <FaIcon
                    icon={getActivityIcon(activity?.type) as IconProp}
                    className="tw-h-3.5 tw-w-3.5 tw-shrink-0 tw-text-content-base"
                  />
                  <span className="tw-w-24 tw-font-medium tw-text-content-base">
                    {t(getActivityName(activity.type))}
                  </span>
                </div>

                <span className="tw-text-xs tw-text-content-secondary">
                  {start.format('HH:mm')}
                  {' – '}
                  {end ? end.format('HH:mm') : '—'}
                </span>
              </div>
            )
          })}
          <DividerHorizontal />
        </div>
      </div>
    </>
  )
}

export default ActivityListChange
